


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { MM_EMPTY_DASH } from '../core/format';
import { getBadgeSpec, MmBadgeDomain, MmBadgeSpec } from '../core/statuses';

@Component
export default class MmStatusBadge extends Vue {
	@Prop({ required: true }) readonly domain!: MmBadgeDomain;

	@Prop({ default: '' }) readonly value!: string;

	@Prop({ default: '' }) readonly size!: string;

	get spec(): MmBadgeSpec | null {
		return getBadgeSpec(this.domain, this.value);
	}

	get label(): string {
		const spec = this.spec;

		if (spec) {
			return this.$t(spec.labelKey) as string;
		}

		const raw = this.value === null || this.value === undefined ? '' : String(this.value).trim();

		return raw !== '' ? raw : MM_EMPTY_DASH;
	}

	get tone(): string {
		const spec = this.spec;

		return spec ? spec.tone : 'neutral';
	}

	get badgeClass(): string {
		const classes = ['sm-mobilemon__badge--' + this.tone];

		if (this.size === 'control') {
			classes.push('sm-mobilemon__badge--control');
		}

		return classes.join(' ');
	}

	/** Глиф не декоративный: бейджи исхода должны различаться без опоры на цвет */
	get icon(): string {
		const spec = this.spec;

		if (!spec || spec.icon === undefined || spec.icon === null) {
			return '';
		}

		return spec.icon;
	}

	get hintText(): string {
		const spec = this.spec;

		if (!spec || spec.hintKey === null) {
			return '';
		}

		return this.$t(spec.hintKey) as string;
	}
}
